<script setup lang="ts">

import {DotLottieVue} from "@lottiefiles/dotlottie-vue";
</script>

<template>
  <div class="text-center">
    <DotLottieVue
      src="animations/hearth-loading.lottie"
      :autoplay="true"
      :loop="true"
      style="height: 300px; width: 300px; cursor: pointer; margin: auto;"
    />
    <p>
      Veuillez patienter, nous regroupons toutes les informations, et générons votre rapport.
    </p>
  </div>
</template>

<style scoped>

</style>
